import styled from "styled-components";

export const CMForgotPasswordModal = styled.div((props) => ({
    minHeight: "300px",
    width: "500px",
    padding: '2rem',
    backgroundColor: "white",
    borderRadius: "8px",
    border: 'solid black 2px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    justifyContent: 'left',

    "& .error": {
        color: "#a80000",
        fontSize: '0.8rem'
    },

    "& .container": {
        padding: '1rem 0',
        display: "flex",
        flexDirection: 'column',
        justifyContent: 'left',
        alignItems: "left"
    },

    '& > div': {
        padding: '1rem 0'
    },

    '& .title': {
        textAlign: 'center',
        borderBottom: `solid 1px #a80000`
    },

    '& .button-container': {
        marginTop: 0,
        
        '& button': {
            marginRight: '1rem',
            textTransform: 'unset',
        }
    },
    
    [`@media${props.theme.breakpoints.md}`]: {
        width:"80%"
    },

    [`@media${props.theme.breakpoints.sm}`]: {
        width:"70%"
    },
}))

